// extracted by mini-css-extract-plugin
export default {"app_layout":"AppLayout_app_layout__zwjzc","app_layout__container":"AppLayout_app_layout__container__Jrmj7","app_layout__main":"AppLayout_app_layout__main__GHtzn"};